import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";

export const YearMonthFilter = ({
  t,
  showAllHistory,
  setShowAllHistory,
  filteredMonth,
  filteredYear,
  handleChangeDate,
  setFilteredMonth,
  setFilteredYear,
}) => {
  const [years, setYears] = useState([]);

  const months = [
    { id: 1, title: "January" },
    { id: 2, title: "February" },
    { id: 3, title: "March" },
    { id: 4, title: "April" },
    { id: 5, title: "May" },
    { id: 6, title: "June" },
    { id: 7, title: "July" },
    { id: 8, title: "August" },
    { id: 9, title: "September" },
    { id: 10, title: "October" },
    { id: 11, title: "November" },
    { id: 12, title: "December" },
  ];

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    const range = (start, stop, step) =>
      Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
      );
    const years = range(2022, currentYear, 1);
    years.sort((a, b) => a - b);
    setYears(years);
  };

  useEffect(() => {
    getYears();
  }, []);
  return (
    <span>
      <button
        className="border border-dark"
        style={{
          background: showAllHistory ? "#5D47B6" : "",
          color: showAllHistory ? "#fff" : "",
        }}
        onClick={() => setShowAllHistory(!showAllHistory)}
      >
        {t("All")}
      </button>
      <Form.Select
        aria-label="Default select example"
        className="ml-2"
        value={filteredYear}
        onChange={(e) => handleChangeDate(e, "year")}
        defaultValue={""}
      >
        <option value={""} disabled={true}>{t("Year")}</option>
        {years?.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </Form.Select>
      <Form.Select
        aria-label="Default select example"
        className="ml-2"
        value={filteredMonth}
        onChange={(e) => handleChangeDate(e, "month")}
        defaultValue={""}
        placeholder="check"
      >
        <option value={""} disabled={true}>{t("Month")}</option>
        {months?.map((item) => (
          <option key={item?.id} value={item?.id}>
            {item?.title}
          </option>
        ))}
      </Form.Select>
      <button
        className="border border-dark ml-2"
        onClick={() => {
          setShowAllHistory(true);
          setFilteredMonth("");
          setFilteredYear("");
        }}
      >
        {t("Clear")}
      </button>
    </span>
  );
};
